import { createSlice } from "@reduxjs/toolkit";

const bulkSparesLotFilterSlice = createSlice({
  name: "bulkSparesLotFilter",
  initialState: {
    seller_id: "",
    status: "",
    request_id: "",
  },
  reducers: {
    setBulkSparesLotFilter: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

// ✅ Consistent export
export const { setBulkSparesLotFilter } = bulkSparesLotFilterSlice.actions;

// ✅ Selector
export const selectBulkSparesLotFilterState = (state) =>
  state.bulkSparesLotFilter;

export default bulkSparesLotFilterSlice.reducer;
